import React, { useState } from 'react';
import { User2Icon, CreditCardIcon, BellIcon, ShieldIcon, KeyIcon, UserIcon, SmileIcon, CatIcon, DogIcon, BirdIcon, ChevronRightIcon, BarChart3Icon, ClockIcon, StarIcon, BoxIcon, AwardIcon, ZapIcon, BrainIcon } from 'lucide-react';
import { mockApps } from '../utils/mockData';
import { useNavigate } from 'react-router-dom';
const avatarOptions = [{
  icon: <UserIcon className="h-6 w-6" data-id="element-1887" />,
  name: 'Default'
}, {
  icon: <SmileIcon className="h-6 w-6" data-id="element-1888" />,
  name: 'Smile'
}, {
  icon: <CatIcon className="h-6 w-6" data-id="element-1889" />,
  name: 'Cat'
}, {
  icon: <DogIcon className="h-6 w-6" data-id="element-1890" />,
  name: 'Dog'
}, {
  icon: <BirdIcon className="h-6 w-6" data-id="element-1891" />,
  name: 'Bird'
}];
const subscriptionTiers = [{
  name: 'Free',
  price: '$0',
  current: true,
  features: ['10 Created AI Apps', '2,000 Monthly Credits', 'Basic Support', 'Community Access']
}, {
  name: 'Pro',
  price: '$9.99/mo',
  current: false,
  features: ['Unlimited Created Apps', '50,000 Monthly Credits', 'Priority Support', 'API Access', 'No Ads']
}, {
  name: 'Enterprise',
  price: 'Custom',
  current: false,
  features: ['Custom AI Models', 'Unlimited Credits', 'Dedicated Support', 'Team Management', 'Custom Integration']
}];
export const MyAccount = () => {
  const navigate = useNavigate();
  const [selectedAvatar, setSelectedAvatar] = useState(0);
  // Calculate mock statistics
  const totalApps = mockApps.length;
  const totalUsage = '234'; // This would come from real usage data
  const avgRating = 4.8;
  const StatCard = ({
    icon: Icon,
    label,
    value
  }: any) => <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-1892">
      <div className="flex items-center justify-between mb-4" data-id="element-1893">
        <div className="text-gray-500" data-id="element-1894">{label}</div>
        <Icon className="h-5 w-5 text-gray-400" data-id="element-1895" />
      </div>
      <div className="text-2xl font-semibold" data-id="element-1896">{value}</div>
    </div>;
  return <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8" data-id="element-1897">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-1898">
        {/* Badges Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1899">
          <div className="px-6 py-8" data-id="element-1900">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1901">My Badges</h2>
            <div className="flex flex-wrap gap-4" data-id="element-1902">
              <div className="flex items-center space-x-3 bg-indigo-50 border border-indigo-200 rounded-full px-4 py-2" data-id="element-1903">
                <AwardIcon className="h-5 w-5 text-indigo-600" data-id="element-1904" />
                <span className="text-indigo-700 font-medium" data-id="element-1905">Developer</span>
              </div>
              <div className="flex items-center space-x-3 bg-purple-50 border border-purple-200 rounded-full px-4 py-2" data-id="element-1906">
                <ZapIcon className="h-5 w-5 text-purple-600" data-id="element-1907" />
                <span className="text-purple-700 font-medium" data-id="element-1908">
                  Early Adopter
                </span>
              </div>
              <div className="flex items-center space-x-3 bg-green-50 border border-green-200 rounded-full px-4 py-2" data-id="element-1909">
                <BrainIcon className="h-5 w-5 text-green-600" data-id="element-1910" />
                <span className="text-green-700 font-medium" data-id="element-1911">Super Nerd</span>
              </div>
            </div>
          </div>
        </div>
        {/* Credits Usage Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1912">
          <div className="px-6 py-8" data-id="element-1913">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1914">Credits</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1915">
              <div className="p-6 border border-gray-200 rounded-lg" data-id="element-1916">
                <div className="flex justify-between items-center mb-4" data-id="element-1917">
                  <span className="text-gray-600" data-id="element-1918">Available Credits</span>
                  <ZapIcon className="h-5 w-5 text-amber-500" data-id="element-1919" />
                </div>
                <div className="text-3xl font-bold" data-id="element-1920">1,459</div>
                <div className="text-sm text-gray-500 mt-2" data-id="element-1921">
                  Resets in 12 days
                </div>
              </div>
              <div className="p-6 border border-gray-200 rounded-lg" data-id="element-1922">
                <div className="flex justify-between items-center mb-4" data-id="element-1923">
                  <span className="text-gray-600" data-id="element-1924">Used This Month</span>
                  <BarChart3Icon className="h-5 w-5 text-indigo-500" data-id="element-1925" />
                </div>
                <div className="text-3xl font-bold" data-id="element-1926">541</div>
                <div className="text-sm text-gray-500 mt-2" data-id="element-1927">
                  of 2,000 monthly credits
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Profile Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1928">
          <div className="px-6 py-8" data-id="element-1929">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1930">My Profile</h2>
            <div className="flex flex-col sm:flex-row items-start gap-8" data-id="element-1931">
              <div className="w-full sm:w-64" data-id="element-1932">
                <div className="mb-4" data-id="element-1933">
                  <div className={`w-32 h-32 rounded-full bg-indigo-100 flex items-center justify-center mb-4`} data-id="element-1934">
                    {avatarOptions[selectedAvatar].icon}
                  </div>
                  <button className="text-sm text-indigo-600 hover:text-indigo-700" data-id="element-1935">
                    Change Avatar
                  </button>
                </div>
                <div className="grid grid-cols-5 gap-2" data-id="element-1936">
                  {avatarOptions.map((option, index) => <button key={index} className={`p-2 rounded-lg border ${selectedAvatar === index ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200 hover:border-indigo-600'}`} onClick={() => setSelectedAvatar(index)} data-id="element-1937">
                      {option.icon}
                    </button>)}
                </div>
              </div>
              <div className="flex-1 w-full" data-id="element-1938">
                <div className="space-y-4" data-id="element-1939">
                  <div data-id="element-1940">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1941">
                      Display Name
                    </label>
                    <input type="text" defaultValue="John Doe" className="w-full border-gray-200 rounded-md px-4 py-2" data-id="element-1942" />
                  </div>
                  <div data-id="element-1943">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1944">
                      Email
                    </label>
                    <input type="email" defaultValue="john@example.com" className="w-full border-gray-200 rounded-md px-4 py-2" data-id="element-1945" />
                  </div>
                  <div data-id="element-1946">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1947">
                      Bio
                    </label>
                    <textarea className="w-full border-gray-200 rounded-md px-4 py-2" rows={3} defaultValue="AI enthusiast and developer" data-id="element-1948" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Dashboard Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1949">
          <StatCard icon={BoxIcon} label="Total Apps" value={totalApps} data-id="element-1950" />
          <StatCard icon={ClockIcon} label="Total Usage" value={`${totalUsage}h`} data-id="element-1951" />
          <StatCard icon={StarIcon} label="Avg. Rating" value={avgRating} data-id="element-1952" />
        </div>
        {/* Subscription Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1953">
          <div className="px-6 py-8" data-id="element-1954">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1955">Subscription</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1956">
              {subscriptionTiers.map(tier => <div key={tier.name} className={`rounded-lg border ${tier.current ? 'border-indigo-600 bg-indigo-50' : 'border-gray-200'} p-6`} data-id="element-1957">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-1958">{tier.name}</h3>
                  <p className="text-2xl font-bold mb-4" data-id="element-1959">{tier.price}</p>
                  <ul className="space-y-2 mb-6" data-id="element-1960">
                    {tier.features.map(feature => <li key={feature} className="flex items-center text-sm" data-id="element-1961">
                        <ChevronRightIcon className="h-4 w-4 text-indigo-600 mr-2" data-id="element-1962" />
                        {feature}
                      </li>)}
                  </ul>
                  <button className={`w-full py-2 rounded-md ${tier.current ? 'bg-indigo-600 text-white' : 'border border-indigo-600 text-indigo-600'}`} data-id="element-1963">
                    {tier.current ? 'Current Plan' : 'Upgrade'}
                  </button>
                </div>)}
            </div>
          </div>
        </div>
        {/* Settings Section */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1964">
          <div className="px-6 py-8" data-id="element-1965">
            <h2 className="text-2xl font-bold mb-6" data-id="element-1966">Settings</h2>
            <div className="space-y-4" data-id="element-1967">
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-1968">
                <div className="flex items-center" data-id="element-1969">
                  <BellIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-1970" />
                  <span data-id="element-1971">Notifications</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-1972" />
              </button>
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-1973">
                <div className="flex items-center" data-id="element-1974">
                  <ShieldIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-1975" />
                  <span data-id="element-1976">Privacy</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-1977" />
              </button>
              <button onClick={() => navigate('/settings')} className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-indigo-600 group" data-id="element-1978">
                <div className="flex items-center" data-id="element-1979">
                  <KeyIcon className="h-5 w-5 text-gray-400 group-hover:text-indigo-600 mr-3" data-id="element-1980" />
                  <span data-id="element-1981">Security</span>
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-1982" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};